import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import VfairLanding from "@modules/vfair/landing";
import { arrayShuffler } from "@unisearch/helpers";

const VfairPage = ({ partnerUniversities }) => {
  return (
    <LayoutMain
      title="Mega University Virtual Fair"
      metaUrl="https://myunisearch.com/vfair"
      metaTitle="Mega University Virtual Fair"
      metaImage={""}
      metaDescription="Mega University Virtual Fair"
      metaKeywords="fair, virtual, virtual fair"
    >
      <VfairLanding partnerUniversities={partnerUniversities} />
    </LayoutMain>
  );
};

export default VfairPage;

export async function getServerSideProps() {
  let props = {
    partnerUniversities: [],
  };

  try {
    await API.get(`/public/partner/universities?skip=0&limit=28`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          if (resp.data && resp.data.length > 0) {
            let data = arrayShuffler(resp.data);
            props.partnerUniversities = data;
          }
        }
      }
    );

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
